import {
  FaGlobe,
  FaChartLine,
  FaClock,
  FaLightbulb,
  FaUsers,
  FaBriefcaseMedical,
  FaBuilding,
} from "react-icons/fa";
import PT from "../img/physicaltherapy.png";
import GF from "../img/generalfitness.png";
import { LANDING_MODE } from "./landingMode";

const landingContent = {
  fitness: {
    intro: {
      headline: "Your Expertise, Their Screen— Seamless Remote Workouts",
      paragraphs: [
        {
          text: "Deliver smarter coaching, scale your programs, and give real-time feedback to your clients—powered by AI, using just a phone",
        },
        {
          text: "Built for fitness trainers who want to scale, without sacrificing quality",
          bold: true,
          breakBefore: true,
        },
      ],
    },
    articles: {
      heading: "Why neonimble is Built for Trainers",
      tagline:
        "Give every client the attention they need—even when you're busy",
      cards: [
        {
          title: "Expand Your Reach",
          description:
            "Coach clients across the world without being tied to a physical location.",
          icon: FaGlobe,
        },
        {
          title: "Increase Revenue Streams",
          description:
            "Create digital training programs, sell online packages, and monetize your time more effectively.",
          icon: FaChartLine,
        },
        {
          title: "Save Time on Repetitive Tasks",
          description:
            "Rep counting, form reviews, and basic feedback are all automated—so you can focus on high-value coaching.",
          icon: FaClock,
        },
        {
          title: "Build a Smarter Brand",
          description:
            "Differentiate yourself with intelligent coaching tools. Deliver a more modern, tech-driven experience to your clients.",
          icon: FaLightbulb,
        },
      ],
    },
    vision: {
      titleLines: ["Create your own digital presence for clients"],
      lead: "Think of neonimble as your new coaching medium",
      bullets: [
        "Create an AI model that mirrors your coaching",
        "Store and organize your workout library",
        "Build structured training plans",
        "Assign workouts with a tap",
        "Monitor real-time data from all your clients",
        "Adapt routines based on actual performance",
      ],
      close: "One app. Total control. Smarter coaching.",
    },
    solutions: {
      heading: "Transforming Fitness Training with AI Innovation",
      slides: [
        {
          image: PT,
          title: "Revolutionary Features",
          desc: [
            "AI-Powered Exercise Modeling: Create custom exercise models with just a video recording. Our advanced AI analyzes movements and builds intelligent models automatically.",
            "Real-Time Performance Feedback: Get instant posture correction, rep counting, and personalized guidance through cutting-edge computer vision technology.",
            "Comprehensive Progress Tracking: Monitor detailed metrics including rep accuracy, posture consistency, and session history in an intuitive dashboard.",
            "Next-Gen Remote Coaching: Deliver personalized training programs, review client performance, and adapt routines remotely with real-time insights.",
            "Smart Analytics Engine: Leverage AI-driven insights to identify patterns, optimize training, and achieve better results for your clients.",
            "Streamlined Client Management: Automate program assignments, progress tracking, and client communications in one unified platform.",
          ],
        },
        {
          image: GF,
          title: "Powered by Advanced Technology",
          desc: [
            "State-of-the-Art Pose Estimation: Combining computer vision and machine learning for precise movement analysis",
            "Intelligent Feedback System: Real-time processing using edge and cloud computing for instant guidance",
            "Adaptive AI Models: Smart algorithms for accurate rep counting and posture evaluation",
            "Enterprise-Grade Security: End-to-end encryption and secure data synchronization",
            "Scalable Infrastructure: Built to handle multiple clients and complex training scenarios",
            "Continuous Learning: AI models that improve with every interaction",
          ],
        },
      ],
    },
    contact: {
      heading: "Let's Connect",
      body: "Have a question or want to work together? Drop me a message! We're always excited to hear about new projects and opportunities.",
      button: "Send Message",
      success: "Thank you for your message! I'll get back to you soon.",
    },
  },

  physio: {
    intro: {
      headline:
        "AI-powered revolution in Physical Therapy and Rehab: Personalized home exercises with real-time feedback",
      paragraphs: [
        { text: "B2B tech platform for physiotherapists & corporates" },
        { text: "Customized home exercises", className: "i-desc-p" },
        {
          text: "Real-time monitoring & precision guidance",
          className: "i-desc-p",
        },
        {
          text: "Improved adherence & faster recovery",
          className: "i-desc-p",
        },
      ],
    },
    articles: {
      heading:
        "Musculoskeletal Disorders (MSD): Leading cause of disability worldwide",
      tagline:
        "Evidence-backed care for joints, bones, and muscles—at home and at work",
      cards: [
        {
          title:
            "1.71 billion people have musculoskeletal conditions worldwide",
          description:
            "Musculoskeletal (MSK) conditions affect many people and can affect your joints, bones and muscles and sometimes associated...",
          icon: FaUsers,
          link: "https://www.who.int/news-room/fact-sheets/detail/musculoskeletal-conditions",
        },
        {
          title: "30 million working days lost every year due to MSD in the UK",
          description:
            "Musculoskeletal health refers to the performance of the locomotor system, comprising intact muscles, bones, joints and adjacent connective tissues. Musculoskeletal impairments ...",
          icon: FaBriefcaseMedical,
          link: "https://www.england.nhs.uk/elective-care-transformation/best-practice-solutions/musculoskeletal/",
        },
        {
          title: "Majority of workforce has work related MSD issues",
          description:
            "76% of employees report WMSDs while working from the office, and 82% reported concerns about body pain while working from home...",
          icon: FaBuilding,
          link: "https://www.biospectrumindia.com/news/98/22182/76-workforce-suffers-from-work-related-musculoskeletal-disorders-godrej-study.html",
        },
      ],
    },
    vision: {
      // titleLines: ["Home Exercises:", "Personalized & Simplified"],
      titleLines: ["Home Exercises, Personalized & Simplified"],
      bullets: [
        "Ease & Simplicity: Without any sensors or special wearables",
        "Freedom & Convenience: Use any device anywhere on demand",
        "Confidence & Adherence: Progress tracking & instant feedback",
      ],
    },
    solutions: {
      heading: "Transforming the existing MSD care with neonimble.ai",
      slides: [
        {
          image: PT,
          title: "Physiotherapists Supported with AI Precision",
          desc: [
            "Enabling you to provide personalized care to your patients at home without you physically being available.",
            "Allowing you to build a tailored home exercise routine based on the patient’s conditions with our easy-to-use interface.",
            "Imitating your presence while your patients perform prescribed exercises at home.",
            "Providing real-time corrective guidance to make your patients feel more confident and safe.",
            "Improving patient adherence to home exercises, thus achieving better recovery outcomes.",
            "Monitoring progress and reporting detailed analytics to help you make informed decisions at speed.",
          ],
        },
        {
          image: GF,
          title: "Corporate Wellness Assisted by AI Precision",
          desc: [
            "Majority of our workforce struggle with work-related MSDs (WMSDs), and it is a leading cause of unplanned absenteeism.",
            "neonimble.ai platform enables you to get your team moving beyond pain by taking care of their joints and muscles.",
            "Drawing upon a robust foundation of rigorous research in exercise science and physical fitness, our AI algorithm tailors personalized fitness plans for your employees, aligning with their specific job requirements and fitness levels.",
            "We will provide you with necessary analytics and insights to support you in your employees’ wellness journey.",
          ],
        },
      ],
    },
    contact: {
      heading: "Let's Connect",
      body: "Have a question or want to work together? Drop me a message! We're always excited to hear about new projects and opportunities.",
      button: "Send Message",
      success: "Thank you for your message! I'll get back to you soon.",
    },
  },
};

if (!landingContent[LANDING_MODE]) {
  throw new Error(
    `Unknown LANDING_MODE "${LANDING_MODE}". Use "fitness" or "physio".`,
  );
}

export const content = landingContent[LANDING_MODE];
export { landingContent };
